module.exports = __webpack_public_path__ + "static/media/traveloka-logo-icon-1.dd57b6de.png";